import { SET_EDITED_MEMBER_DATA } from '../../store/member/MemberConstants'

export const managementBlackList = [SET_EDITED_MEMBER_DATA]
